;(function() {
  'use strict'

  angular.module('app.core').component('unauthWrapper', {
    templateUrl: 'unauth-wrapper.html',
    transclude: true,
  })
})()
